export default __webpack_public_path__ + "static/media/mobile_risks.8335fee6.svg";